import React from "react";
import Router from "@al/next/router";
import PropTypes from "prop-types";

import styles from "./index.scss";

export default class PageProgress extends React.Component {
  static propTypes = {
    width: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
    };
    this.rStartInterval = null;
    this.clearProgressTimer = null;
  }

  componentDidMount() {
    Router.events.on("routeChangeStart", this.handleRouteChange);
    Router.events.on("routeChangeComplete", this.handleRouteChangeComplete);
  }

  componentWillUnmount() {
    Router.events.off("routeChangeStart", this.handleRouteChange);
    Router.events.off("routeChangeComplete", this.handleRouteChangeComplete);
    clearInterval(this.rStartInterval);
    clearTimeout(this.clearProgressTimer);
    this.rStartInterval = null;
    this.clearProgressTimer = null;
  }

  handleRouteChange = (url) => {
    this.setState({
      routerChangeComplete: false,
    });
    const changeProgress = () => {
      if (this.state.routerChangeComplete) return;
      if (0 === this.state.progress) {
        this.setState({
          progress: 30,
        });
      } else if (90 >= this.state.progress) {
        this.setState({
          progress: this.state.progress + 5,
        });
        const timer = setTimeout(() => {
          changeProgress();
          clearTimeout(timer);
        }, 30);
      }
    };

    //延迟500ms展示进度条
    this.rStartTimer = setTimeout(() => {
      changeProgress();
      clearTimeout(this.rStartTimer);
    }, 500);
  };

  handleRouteChangeComplete = () => {
    //未开启进度条
    if (this.state.progress === 0) {
      return this.setState({
        routerChangeComplete: true,
      });
    } else {
      this.setState({
        progress: 100,
        routerChangeComplete: true,
      });
      this.clearProgressTimer = setTimeout(() => {
        this.setState({
          progress: 0,
        });
        clearTimeout(this.clearProgressTimer);
      }, 500);
    }
  };

  render() {
    const { progress } = this.state;
    return (
      <div className={styles["page-render-wrap"]}>
        <div className={styles["page-render-progress"]} style={{ width: `${progress}%` }} />
      </div>
    );
  }
}
